import React from 'react';
import { useTranslation } from 'react-i18next';

function DefaultLayout() {
  const { t } = useTranslation();

  return (
    <div className="news-lightbox-container">
      <h2>{t('sorry-dialog')}</h2>
    </div>
  );
}

export default DefaultLayout;

